export default {
  setItens(state, payload) {
    state.itens = payload;
  }
};
